export { default } from './core/createTheme';
